import { useState } from 'react';
import {
    IconButton,
    MenuItem,
    MenuSubTrigger,
    Menu,
    MenuContent,
    MenuGroup,
    MenuRadioGroup,
    MenuRadioItem,
    MenuSub,
    MenuSubContent,
    MenuTrigger,
    Text,
} from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { startCase } from 'lodash';
import { QueueDisplayDensityEnum, QueueDisplayDensityEnumType } from '@mark43/cad-api';
import { FrQueueColumnSelectModal } from './fr-queue-column-select-modal';
import { useQueueStore } from '../../../queues/context/use-queue-store';
import { useBoloQueueWorkspacePanel } from '../../hooks/use-bolo-queue-workspace-panel';
import { QueueStateProvider } from '../../../queues/context/queue-state-provider';
import { useFrEventsListTab } from '../../../fr-events-list-page/fr-events-list-context';

export const FrQueueOtherOptionsMenu = observer(function FrQueueOtherOptionsMenu({
    showDisplayTypeOption = true,
}: {
    showDisplayTypeOption?: boolean;
}) {
    const queueStore = useQueueStore();
    const { tab } = useFrEventsListTab();
    const [showColumnSelection, setShowColumnSelection] = useState(false);
    const handleColumnSelectorOpen = () => setShowColumnSelection(true);
    const handleColumnSelectorClose = () => setShowColumnSelection(false);
    const isCompactView =
        queueStore.workspacePanel.queue.displayDensity === QueueDisplayDensityEnum.COMPACT.name;
    const boloPanel = useBoloQueueWorkspacePanel();

    const eventEditColumnsElement = (
        <FrQueueColumnSelectModal
            isOpen={showColumnSelection}
            onClose={handleColumnSelectorClose}
        />
    );

    const boloEditColumnsElement = boloPanel && (
        <QueueStateProvider workspacePanel={boloPanel}>
            <FrQueueColumnSelectModal
                isOpen={showColumnSelection}
                onClose={handleColumnSelectorClose}
            />
        </QueueStateProvider>
    );

    return (
        <>
            <Menu>
                <MenuTrigger asChild>
                    <IconButton
                        data-testid="fr-other-options-menu"
                        variant="ghost"
                        icon="MoreActions"
                        aria-label="more actions"
                    />
                </MenuTrigger>
                <MenuContent>
                    <MenuGroup title="View">
                        {showDisplayTypeOption && (
                            <MenuSub>
                                <MenuSubTrigger>Display Type</MenuSubTrigger>
                                <MenuSubContent>
                                    <MenuRadioGroup
                                        value={queueStore.workspacePanel.queue.displayDensity}
                                        onValueChange={(value) =>
                                            queueStore.setDisplayDensity(
                                                value as QueueDisplayDensityEnumType
                                            )
                                        }
                                    >
                                        <MenuRadioItem value={QueueDisplayDensityEnum.CLASSIC.name}>
                                            {startCase(
                                                QueueDisplayDensityEnum.CLASSIC.name.toLowerCase()
                                            )}
                                        </MenuRadioItem>
                                        <MenuRadioItem value={QueueDisplayDensityEnum.COMPACT.name}>
                                            {startCase(
                                                QueueDisplayDensityEnum.COMPACT.name.toLowerCase()
                                            )}
                                        </MenuRadioItem>
                                    </MenuRadioGroup>
                                </MenuSubContent>
                            </MenuSub>
                        )}
                        {isCompactView && (
                            <MenuItem onSelect={handleColumnSelectorOpen}>
                                <Text fontSize="sm">Edit Columns</Text>
                            </MenuItem>
                        )}
                    </MenuGroup>
                </MenuContent>
            </Menu>
            {isCompactView && (
                <>
                    {tab !== 'BOLO' && eventEditColumnsElement}
                    {tab === 'BOLO' && boloEditColumnsElement}
                </>
            )}
        </>
    );
});
